import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventNames, EVENTS } from '@app/constants/events.constants';
import { ItemsToSetUpListSubjectService } from '@app/modules/vault/components/add-document/items-to-set-up/items-to-set-up.subject';
import { DocumentService, UserService } from '@app/shared/services';
import { ShareService } from '@app/shared/services/vault/share.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
enum EAttributesTypes {
  financialAttribute = 'financial-attribute',
  insuranceAttribute = 'insurance-attribute',
}

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'dynamic-attributes-dialog',
  templateUrl: './dynamic-attributes-dialog.component.html',
  styleUrls: ['./dynamic-attributes-dialog.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicAttributesDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('formTemplate') formTemplate: ElementRef;

  @Input() inputData;
  @Output() formSetupSideBarEmitter = new EventEmitter<any>();
  today = new Date();
  attributeForm: UntypedFormGroup;
  subscription: Subscription = new Subscription();
  cryptoItems = [];
  focusId = '';
  itemsToSetUpList = [];
  @Input() hide_mark_complete = false;
  setupItem = undefined;
  isSetupItemEnable = false;
  @Input() fromSetup = false;
  moment = moment;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() private dialogRef: MatDialogRef<DynamicAttributesDialogComponent>,
    private fb: UntypedFormBuilder,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
    private shareService: ShareService,
    private _userService: UserService,
    private documentService: DocumentService,
    private itemsToSetUpListSubjectService: ItemsToSetUpListSubjectService,
    private http: HttpClient
  ) {}

  async ngOnInit(): Promise<any> {
    this.subscription.add(
      this.itemsToSetUpListSubjectService.itemsToSetUpList.subscribe((res) => {
        this.itemsToSetUpList = res;
        if (res.length > 0 && (!!this.data?.existingAttributesList || !!this.inputData?.vault_form_code)) {
          this.setupItem = res?.find((item) => {
            return !!item?.sub_type
              ? item?.sub_type?.toLowerCase() ==
                  (this.data?.existingAttributesList?.value?.vault_form_code?.toLowerCase() || this.inputData?.vault_form_code?.toLowerCase())
              : undefined;
          });
          if (this.setupItem?.status == 'complete') this.isSetupItemEnable = true;
        }
      })
    );
    this.handleExistingAttributesListForTemplate();
    let isUpdatingForm = false;
    this.subscription.add(
      this.attributeForm.valueChanges.subscribe((val) => {
        if (isUpdatingForm) return;
        isUpdatingForm = true;
        if (!!this.inputData) {
          this.inputData?.attributes.forEach((attribute) => {
            if (!!attribute.condition) {
              const condition = eval(`(${attribute.condition})`);
              const conditionKey = Object.keys(condition)[0];
              const conditionValue = condition[conditionKey];
              if (val[conditionKey] === conditionValue) {
                const attributeExist = this.formKeys.find((key) => key.key === attribute.key);
                if (!!!attributeExist) {
                  const sameTitleExist = this.formKeys.find((key) => key.title === attribute.title);
                  if (!!sameTitleExist) {
                    this.attributeForm.removeControl(sameTitleExist.key);
                    this.formKeys = this.formKeys.filter((key) => key.key !== sameTitleExist.key);
                  }
                  this.attributeForm.addControl(attribute.key, this.fb.control('', []));
                  const indexOfAttribute = this.formKeys.findIndex((key) => key.key === conditionKey);
                  this.formKeys.splice(indexOfAttribute + 1, 0, {
                    key: attribute.key,
                    title: attribute.title,
                    type: attribute.type,
                    value: '',
                    condition: attribute.condition,
                  });
                }
              }
            }
          });
        } else {
          this.data.attributes.forEach((attribute) => {
            if (!!attribute.condition) {
              const condition = eval(`(${attribute.condition})`);
              const conditionKey = Object.keys(condition)[0];
              const conditionValue = condition[conditionKey];
              if (val[conditionKey] === conditionValue) {
                const attributeExist = this.formKeys.find((key) => key.key === attribute.key);
                if (!attributeExist) {
                  const sameTitleExist = this.formKeys.find((key) => key.title === attribute.title);
                  if (!!sameTitleExist) {
                    this.attributeForm.removeControl(sameTitleExist.key);
                    this.formKeys = this.formKeys.filter((key) => key.key !== sameTitleExist.key);
                  }
                  this.attributeForm.addControl(attribute.key, this.fb.control('', []));
                  const indexOfAttribute = this.formKeys.findIndex((key) => key.key === conditionKey);
                  this.formKeys.splice(indexOfAttribute + 1, 0, {
                    key: attribute.key,
                    title: attribute.title,
                    type: attribute.type,
                    value: '',
                    condition: attribute.condition,
                  });
                }
              }
            }
          });
        }
        setTimeout(() => (isUpdatingForm = false), 0);
      })
    );
    this.subscription.add(
      this.http.get<any>('/assets/json/currencies-list.json').subscribe((data) => {
        this.currencies = Object.keys(data);
      })
    );
  }
  currencies = [];

  closeDialog(val?: string) {
    this.dialogRef.close(val);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  formKeys = [];
  handleExistingAttributesListForTemplate() {
    const formControls: { [key: string]: any } = {};

    if (!!this.inputData) {
      const { getFormValues } = this.inputData?.attribute;
      this.inputData?.attributes.forEach((input, index) => {
        const { key, type, title, condition } = input;
        const isNotEditable = input?.default || input?.multiply || input?.subtract;
        let value: Date | string | number | undefined = '';

        if (key.includes('as_of') || key.includes('effective_date') || type.toLowerCase().includes('date')) {
          formControls[key?.toLowerCase()] = [new Date(), [Validators.required]];
          this.formKeys.push({
            key,
            title,
            type,
            isNotEditable,
            value: value ?? '',
            condition,
          });
        } else {
          if (!!getFormValues?.attribute?.value) {
            const parsedValues = JSON.parse(this.inputData?.attribute?.value);
            let dValue =
              !!parsedValues && !!parsedValues[key?.toLowerCase()]
                ? parsedValues[key?.toLowerCase()]
                : !!parsedValues && !!parsedValues[key?.toUpperCase()]
                ? parsedValues[key?.toUpperCase()]
                : '';

            if (parsedValues && parsedValues[key?.toLowerCase()]) {
              formControls[key?.toLowerCase()] = [dValue ?? '', []];
              this.formKeys.push({
                key,
                title,
                type,
                value: dValue ?? '',
                condition,
              });
            }
          } else {
            if (!condition) {
              formControls[key?.toLowerCase()] = ['', [Validators.required]];
              this.formKeys.push({
                key,
                title,
                type,
                value: value ?? '',
                condition,
              });
            }
          }
        }
        // console.log({ formControls, formKeys: this.formKeys });
      });
    } else {
      this.data?.attributes?.forEach((input, index) => {
        const { getFormValues } = this.data?.attribute;
        const { key, type, title, condition } = input;
        const isNotEditable = input?.default || input?.multiply || input?.subtract;
        let value: Date | string | number | undefined = '';

        if (key.includes('as_of') || key.includes('effective_date') || (typeof type == 'string' && type.toLowerCase().includes('date'))) {
          formControls[key?.toLowerCase()] = [new Date(), [Validators.required]];
          this.formKeys.push({
            key,
            title,
            type,
            isNotEditable,
            value: value ?? '',
            condition,
          });
        } else {
          if (!!getFormValues?.attribute?.value) {
            const parsedValues = JSON.parse(getFormValues?.attribute?.value);
            if (!!parsedValues && parsedValues[key?.toLowerCase()]) {
              let dValue =
                !!parsedValues && !!parsedValues[key?.toLowerCase()]
                  ? parsedValues[key?.toLowerCase()]
                  : !!parsedValues && !!parsedValues[key?.toUpperCase()]
                  ? parsedValues[key?.toUpperCase()]
                  : '';
              formControls[key?.toLowerCase()] = [dValue ?? '', []];
              this.formKeys.push({
                key,
                title,
                type,
                value: dValue ?? '',
                condition,
              });
            }
          } else {
            // console.log({ condition });

            if (!condition) {
              formControls[key?.toLowerCase()] = ['', [Validators.required]];
              this.formKeys.push({
                key,
                title,
                type,
                value: value ?? '',
                condition,
              });
            }
          }
        }
        // console.log({ formControls, formKeys: this.formKeys });
      });
    }

    this.attributeForm = this.fb.group(formControls);
    this.cd.detectChanges();
  }
  ngAfterViewInit(): void {
    const dialogEl = this.formTemplate?.nativeElement?.querySelector('input');
    setTimeout(() => {
      dialogEl?.focus();
      dialogEl?.click();
    }, 500);

    this.cd.detectChanges();
  }

  setValue(ev: Event | any, type?: any) {
    this.attributeForm.controls[`${type}`].setValue(`${ev}`);
    this.cd.detectChanges();
  }

  convertObjectValuesToNumbers(obj: any) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === 'string' && !isNaN((value as any).replace(/,/g, ''))) {
        result[key] = parseFloat(value.replace(/,/g, ''));
      } else {
        result[key] = value;
      }
    }
    return result;
  }

  transFormToNumber(val) {
    if (typeof val == 'number') return val;
    return parseFloat(val.replace(/,/g, ''));
  }
  createArrayFromNumber(number: number) {
    const result: any[] = [];
    for (let i = 0; i <= number; i++) {
      result.push(`${i}`);
    }
    return result;
  }
  handleDropDownTypes(control: any) {
    if (control.type == 'Dropdown 1') return ['Weekly', 'Monthly', 'Bi-Monthly', 'Quarterly', 'Semi-Annually', 'Annually'];
    if (control.type == 'Dropdown 2') return this.createArrayFromNumber(50);
    if (control.type == 'Dropdown 5') return this.createArrayFromNumber(50);
    if (control.type == 'Dropdown 7') return this.createArrayFromNumber(50);
    if (control.type == 'Dropdown 15') return this.getYearsArray(1990);
    if (control.type == 'Dropdown 8') return this.cryptoItems;
    if (control.type == 'Dropdown 12') return ['Gold', 'Silver', 'Platinum', 'Palladium'];
    if (control.type == 'Dropdown 13') return ['Troy Ounce', 'Gram'];
    if (control.type == 'Dropdown 11') return this.currencies;
    if (control.type == 'Dropdown 14') return ['Dollar', 'Percentage'];
    if (control.type == 'Double Dropdown 1') return ['Month', 'Year'];
    if (control.type == 'Dropdown 16') return ['Days', 'Weeks', 'Months', 'Years'];
  }
  getYearsArray(startYear) {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];

    for (let year = startYear; year <= currentYear; year++) {
      yearsArray.push(year);
    }

    return yearsArray;
  }
  getType(controlValue) {
    if (Array.isArray(controlValue)) return true;
    return false;
  }
  hasCategoryDropDown(control: any): boolean {
    if (
      control?.key == 'Income & Expense' ||
      control?.type == 'Income & Expense' ||
      control?.type == 'Dropdown 1'
      // ||
      // control?.key == 'Assets & Liabilities' ||
      // control?.type == 'Assets & Liabilities'
    )
      return true;
  }

  getValueFromInput(input) {
    return !!this.data?.balanceData?.unstringData ? this.data?.balanceData?.unstringData[input?.toLowerCase().replace(/\s+/g, '_')] : null;
  }
  titleHasRegisterBalance(title: string) {
    return !!!this.data.registerBalanceKeys?.includes(title);
  }
  toggleActive(event) {
    const { checked } = event;
    this.isSetupItemEnable = checked;
  }

  trackEventsInMixPanel(events: { eventName: EventNames; data?: any }[]) {
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }

  submitForm() {
    if ((!!this.isSetupItemEnable && this.attributeForm.invalid) || (this.setupItem?.status == 'complete' && !this.isSetupItemEnable)) {
      if (!this.inputData) this.dialogRef.close({ setupItem: this.setupItem });
      if (this.inputData) {
        this.subscription.add(
          this.documentService
            .updateItemsToSetUpList({
              id: this.setupItem.id,
              status: this.setupItem?.status == 'complete' ? 'created' : 'complete',
              setupLabel: this.inputData?.title,
            })
            .subscribe((res) => {
              this.formSetupSideBarEmitter.emit({
                type: 'update',
                status: this.isSetupItemEnable ? 'complete' : 'created',
              });
            })
        );
      }
    } else {
      const date = new Date();
      let updatedObject = { ...this.attributeForm.value };
      let payload: any = {
        type: !!this.inputData ? this.inputData?.vault_form_code : this.data?.attributeData?.type ?? this.data?.triggeredFrom,
        user_id: !!this.inputData ? this.inputData?.user_id : this.data?.userId,
        vault_user_form_id: !!this.inputData ? !!this.inputData?.vault_user_form_id : this.data?.currentFormId,
      };

      updatedObject = this.convertObjectValuesToNumbers({ ...this.attributeForm.value });

      if (!!this.data?.attribute?.getFormValues?.attribute?.id) {
        payload = {
          ...payload,
          id: this.data?.attribute?.getFormValues?.attribute?.id,
        };
        payload = {
          ...payload,
          attribute_type: !!this.inputData ? this.inputData?.attribute_type : this.data?.attribute_type,
          type: !!this.inputData ? this.inputData?.vault_form_code : this.data?.attribute?.value?.vault_form_code,
          value: JSON.stringify(updatedObject),
          effective_date: `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`,
        };
        // console.log({ payload });

        this.updateFinancialAttribute({ ...payload, attribute_type: this.data.attribute_type, attribute_label: this.inputData?.title });
      } else {
        payload = {
          ...payload,
          effective_date: `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`,
          attribute_type: !!this.inputData ? this.inputData?.attribute_type : this.data.attribute_type,
          type: !!this.inputData ? this.inputData?.vault_form_code : this.data.attribute?.value?.vault_form_code,
          value: JSON.stringify(updatedObject),
        };
        if (!!this.inputData && !this.isSetupItemEnable) this.isSetupItemEnable = true;
        this.subscription.add(
          this.documentService.createVaultUserFormFinancialAttribute(payload).subscribe(
            (res) => {
              if (this.inputData) {
                const attribute_type = !!this.inputData ? this.inputData?.attribute_type : this.data?.attribute_type;
                const form_name = !!this.inputData ? this.inputData?.form_name : this.data?.form_name;
                const title = !!this.inputData ? this.inputData?.title : this.data?.title;
                const source = this.fromSetup ? 'setup' : 'view';
                this.trackEventsInMixPanel([
                  {
                    eventName: EVENTS[`template_${source}_add_${attribute_type}_attributes`],
                    data: { attribute_type, form_name, title },
                  },
                ]);
                this.subscription.add(
                  this.documentService
                    .updateItemsToSetUpList({
                      id: this.setupItem.id,
                      status: this.setupItem?.status == 'complete' ? 'created' : 'complete',
                      setupLabel: this.inputData?.title,
                    })
                    .subscribe((res) => {
                      this.formSetupSideBarEmitter.emit({
                        type: 'update',
                        status: this.isSetupItemEnable ? 'complete' : 'created',
                      });
                    })
                );
              }
              if (res.status == 200) this.closeDialog('update');
            },
            (error: any) => {
              this.toastr.error(error);
            }
          )
        );
      }
    }
  }

  addBalance(BALANCE_DETAIL) {
    if (!!this.inputData && !this.isSetupItemEnable) this.isSetupItemEnable = true;
    this.subscription.add(
      this.shareService.createBalanceEntry(BALANCE_DETAIL).subscribe(
        (response) => {
          this.toastr.success('Value Added successfully.');
          const attribute_type = !!this.inputData ? this.inputData?.attribute_type : this.data?.attribute_type;
          const form_name = !!this.inputData ? this.inputData?.form_name : this.data?.form_name;
          const title = !!this.inputData ? this.inputData?.title : this.data?.title;
          const source = this.fromSetup ? 'setup' : 'view';
          this.trackEventsInMixPanel([
            {
              eventName: EVENTS[`template_${source}_add_${attribute_type}_attributes`],
              data: { attribute_type, form_name, title },
            },
          ]);
          if (this.inputData) {
            this.subscription.add(
              this.documentService
                .updateItemsToSetUpList({
                  id: this.setupItem.id,
                  status: this.setupItem?.status == 'complete' ? 'created' : 'complete',
                  setupLabel: this.inputData?.title,
                })
                .subscribe((res) => {
                  this.formSetupSideBarEmitter.emit({ type: 'update', status: this.isSetupItemEnable ? 'complete' : 'created' });
                })
            );
          } else {
            if (this.setupItem?.status != 'complete') {
              this.dialogRef.close({
                isSuccess: true,
                setupItem: this.setupItem,
              });
            } else {
              this.dialogRef.close({
                isSuccess: true,
                // setupItem: this.setupItem
              });
            }
          }
        },
        (error) => {
          this.toastr.error(error);
        }
      )
    );
  }
  updateBalance(BALANCE_DETAIL) {
    if (!!this.inputData && !this.isSetupItemEnable) this.isSetupItemEnable = true;
    this.subscription.add(
      this.shareService.updateBalanceEntry(BALANCE_DETAIL).subscribe(
        (response) => {
          this.toastr.success('Value Added successfully.');
          const attribute_type = !!this.inputData ? this.inputData?.attribute_type : this.data?.attribute_type;
          const form_name = !!this.inputData ? this.inputData?.form_name : this.data?.form_name;
          const title = !!this.inputData ? this.inputData?.title : this.data?.title;
          const source = this.fromSetup ? 'setup' : 'view';
          this.trackEventsInMixPanel([
            {
              eventName: EVENTS[`template_${source}_edit_${attribute_type}_attributes`],
              data: { attribute_type, form_name, title },
            },
          ]);
          if (this.inputData) {
            this.subscription.add(
              this.documentService
                .updateItemsToSetUpList({
                  id: this.setupItem.id,
                  status: this.setupItem?.status == 'complete' ? 'created' : 'complete',
                  setupLabel: this.inputData?.title,
                })
                .subscribe((res) => {
                  this.formSetupSideBarEmitter.emit({ type: 'update', status: this.isSetupItemEnable ? 'complete' : 'created' });
                })
            );
          } else {
            if (this.setupItem?.status != 'complete') {
              this.dialogRef.close({
                isSuccess: true,
                setupItem: this.setupItem,
              });
            } else {
              this.dialogRef.close({
                isSuccess: true,
                // setupItem: this.setupItem
              });
            }
          }
        },
        (error) => {
          this.toastr.error(error);
        }
      )
    );
  }
  updateFinancialAttribute(payload: unknown) {
    if (!!this.inputData && !this.isSetupItemEnable) this.isSetupItemEnable = true;
    this.subscription.add(
      this.documentService.updateVaultUserFormFinancialAttribute(payload).subscribe(
        (res) => {
          if (this.inputData) {
            const attribute_type = !!this.inputData ? this.inputData?.attribute_type : this.data?.attribute_type;
            const form_name = !!this.inputData ? this.inputData?.form_name : this.data?.form_name;
            const title = !!this.inputData ? this.inputData?.title : this.data?.title;
            const source = this.fromSetup ? 'setup' : 'view';
            this.trackEventsInMixPanel([
              {
                eventName: EVENTS[`template_${source}_edit_${attribute_type}_attributes`],
                data: { attribute_type, form_name, title },
              },
            ]);
            this.subscription.add(
              this.documentService
                .updateItemsToSetUpList({
                  id: this.setupItem.id,
                  status: this.setupItem?.status == 'complete' ? 'created' : 'complete',
                  setupLabel: this.inputData?.title,
                })
                .subscribe((res) => {
                  this.formSetupSideBarEmitter.emit({
                    type: 'update',
                    status: this.isSetupItemEnable ? 'complete' : 'created',
                  });
                })
            );
          }
          if (res.status == 200) this.closeDialog('update');
        },
        (error: any) => {
          this.toastr.error(error);
        }
      )
    );
  }

  currencyObject = {};
  handleDateChange(data, controlName, control_) {
    let value;
    let control;
    if (data?.target?.value) {
      value = data?.target?.value;
      value = value.replace(/\//g, '-');
      control = {
        ...control_,
        value,
      };
      this.attributeForm.controls[controlName].setValue(this.moment(value, 'DD-MM-YYYY'));
      this.setValue(this.moment(value, 'DD-MM-YYYY'), control);
      this.formKeys = this.formKeys.map((key) => {
        if (key.key === controlName) {
          return {
            ...key,
            value: value,
          };
        }
        return key;
      });
      this.cd.detectChanges();
    }
  }
}
